import { css } from "@vitality-ds/system";

// eslint-disable-next-line import/prefer-default-export
export var BaseIconButtonWrapper = css({
  // @Todo When we have the primitives package, this should become an internal variant
  button: {
    padding: 0,
    $$size: "1.5rem",
    height: "$$size",
    width: "$$size"
  }
});